<template>
    <layout-machine-introduction :unsaved-puri-count="unsavedPuriCount"
                                 :latest-image-id="latestImageId"
                                 :is-searchable="isSearchable"
                                 :machine-id="machineId"
                                 :section-title-list="sectionTitleList"
                                 :has-top-border-anchor-link="false"
                                 :has-title-anchor-link="false"
                                 :has-border-anchor-link="false"
                                 :has-movie-title="false"
                                 youtube-url="https://youtu.be/Gav3n7COUH4"
    >
        <template v-slot:feature-summary>
            <img :src="buildImgUrl('img_feature_summary.png')" alt="">
        </template>

        <template v-slot:accordion-section>
            <div class="c-machine-introduction-contents">
                <div v-show="isAccordionClosed.cont1" class="accordion">
                    <h3><img :src="buildImgUrl('img_contents01_heading_on.png')" alt="プリとプロジェクターフォトの写り"
                             v-on:click="switchingOpenClosed('cont1')"></h3>
                </div>
                <div v-show="!isAccordionClosed.cont1">
                    <h3><img :src="buildImgUrl('img_contents01_heading_off.png')" alt=""
                             v-on:click="switchingOpenClosed('cont1')"></h3>
                    <div class="cont-01 accordion-inner">
                        <img :src="buildImgUrl('img_contents01_01.png')"
                             alt="どんな想い出も可愛く残せる プリとプロジェクターフォト">
                        <img class="img-02" :src="buildImgUrl('img_contents01_02.png')"
                             alt="プリの写り キラッと華やかビジュ くっきり可愛く盛れるよ プロジェクターの写り 自分らしさを残しつつ可愛く盛れる写り 新しい盛れ感が超可愛い">
                    </div>
                </div>
            </div>

            <div class="c-machine-introduction-contents">
                <div v-show="isAccordionClosed.cont2" class="accordion">
                    <h3><img :src="buildImgUrl('img_contents02_heading_on.png')" alt="プリとプロジェクターフォトの写り"
                             v-on:click="switchingOpenClosed('cont2')"></h3>
                </div>
                <div v-show="!isAccordionClosed.cont2">
                    <h3><img :src="buildImgUrl('img_contents02_heading_off.png')" alt=""
                             v-on:click="switchingOpenClosed('cont2')"></h3>
                    <div class="cont-02 accordion-inner">
                        <div class="cont-02">
                            <img :src="buildImgUrl('img_contents02_00.png')"
                                 alt="今日の気分に合うテーマを選ぶと　ゲーム全体がピッタリの内容に変化！">

                            <div class="img-wrapper">
                                <img :src="buildImgUrl('daily.png')" alt="日常 daily">
                                <img v-show="isAccordionClosed.daily" class="show-or-close-btn"
                                     :src="buildImgUrl('show_more_btn.png')" alt="もっと見る"
                                     v-on:click="switchingOpenClosed('daily')">
                                <img v-show="!isAccordionClosed.daily" class="show-or-close-btn" :src="buildImgUrl('close_btn.png')" alt="閉じる"
                                     v-on:click="switchingOpenClosed('daily')">
                            </div>
                            <div v-show="!isAccordionClosed.daily">
                                <img :src="buildImgUrl('daily_01.png')" alt="プロジェクターデザイン一覧　日常　1〜3">
                                <img :src="buildImgUrl('daily_02.png')" alt="プロジェクターデザイン一覧　日常　4〜7">
                                <img :src="buildImgUrl('daily_03.png')" alt="プロジェクターデザイン一覧　日常　8〜14">
                                <img :src="buildImgUrl('daily_04.png')" alt="プロジェクターデザイン一覧　日常　15〜16">
                                <img :src="buildImgUrl('daily_05.png')" alt="プロジェクターデザイン一覧　日常　17〜20">
                                <img :src="buildImgUrl('daily_06.png')" alt="プロジェクターデザイン一覧　日常　21〜25">
                            </div>


                            <div class="img-wrapper">
                                <img :src="buildImgUrl('school.png')" alt="学校 school">
                                <img v-show="isAccordionClosed.school" class="show-or-close-btn"
                                     :src="buildImgUrl('show_more_btn.png')" alt="もっと見る"
                                     v-on:click="switchingOpenClosed('school')">
                                <img v-show="!isAccordionClosed.school" class="show-or-close-btn" :src="buildImgUrl('close_btn.png')" alt="閉じる"
                                     v-on:click="switchingOpenClosed('school')">
                            </div>
                            <div v-show="!isAccordionClosed.school">
                                <img :src="buildImgUrl('school_01.png')" alt="プロジェクターデザイン一覧　学校　1〜3">
                                <img :src="buildImgUrl('school_02.png')" alt="プロジェクターデザイン一覧　学校　4〜7">
                                <img :src="buildImgUrl('school_03.png')" alt="プロジェクターデザイン一覧　学校　8〜12">
                                <img :src="buildImgUrl('school_04.png')" alt="プロジェクターデザイン一覧　学校　13〜18">
                                <img :src="buildImgUrl('school_05.png')" alt="プロジェクターデザイン一覧　学校　19〜23">
                            </div>

                            <div class="img-wrapper">
                                <img :src="buildImgUrl('season.png')" alt="季節 season">
                                <img v-show="isAccordionClosed.season" class="show-or-close-btn"
                                     :src="buildImgUrl('show_more_btn.png')" alt="もっと見る"
                                     v-on:click="switchingOpenClosed('season')">
                                <img v-show="!isAccordionClosed.season" class="show-or-close-btn" :src="buildImgUrl('close_btn.png')" alt="閉じる"
                                     v-on:click="switchingOpenClosed('season')">
                            </div>
                            <div v-show="!isAccordionClosed.season">
                                <img :src="buildImgUrl('season_01.png')" alt="プロジェクターデザイン一覧　季節　1〜3">
                                <img :src="buildImgUrl('season_02.png')" alt="プロジェクターデザイン一覧　季節　4〜6">
                                <img :src="buildImgUrl('season_03.png')" alt="プロジェクターデザイン一覧　季節　7〜9">
                                <img :src="buildImgUrl('season_04.png')" alt="プロジェクターデザイン一覧　季節　10〜12">
                                <img :src="buildImgUrl('season_05.png')" alt="プロジェクターデザイン一覧　季節　13〜15">
                                <img :src="buildImgUrl('season_06.png')" alt="プロジェクターデザイン一覧　季節　16〜20">
                                <img :src="buildImgUrl('season_07.png')" alt="プロジェクターデザイン一覧　季節　21〜23">
                                <img :src="buildImgUrl('season_08.png')" alt="プロジェクターデザイン一覧　季節　24〜26">
                            </div>

                            <div class="img-wrapper">
                                <img :src="buildImgUrl('anniversary.png')" alt="記念日 anniversary">
                                <img v-show="isAccordionClosed.anniversary" class="show-or-close-btn"
                                     :src="buildImgUrl('show_more_btn.png')" alt="もっと見る"
                                     v-on:click="switchingOpenClosed('anniversary')">
                                <img v-show="!isAccordionClosed.anniversary" class="show-or-close-btn" :src="buildImgUrl('close_btn.png')" alt="閉じる"
                                     v-on:click="switchingOpenClosed('anniversary')">
                            </div>
                            <div v-show="!isAccordionClosed.anniversary">
                                <img :src="buildImgUrl('anniversary_01.png')"
                                     alt="プロジェクターデザイン一覧　記念日　1〜4">
                            </div>


                            <div class="img-wrapper">
                                <img :src="buildImgUrl('trend_design.png')" alt="トレンドデザイン trend_design">
                                <img v-show="isAccordionClosed.trend_design" class="show-or-close-btn"
                                     :src="buildImgUrl('show_more_btn.png')" alt="もっと見る"
                                     v-on:click="switchingOpenClosed('trend_design')">
                                <img v-show="!isAccordionClosed.trend_design" class="show-or-close-btn" :src="buildImgUrl('close_btn.png')" alt="閉じる"
                                     v-on:click="switchingOpenClosed('trend_design')">
                            </div>
                            <div v-show="!isAccordionClosed.trend_design">
                                <img :src="buildImgUrl('trend_design_01.png')"
                                     alt="トレンドデザインを2枚 テーマに追加して選べるよ！">
                                <img :src="buildImgUrl('trend_design_02.png')"
                                     alt="選んだ撮影テーマに合わせて自分好みにアレンジしてね！">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </layout-machine-introduction>
</template>

<script>
import LayoutMachineIntroduction from "../../templates/LayoutMachineIntroduction.vue";
import * as urlUtil from "../../../util/UrlUtil";
import {mapActions} from "vuex";

export default {
    name: "MachineEverFilm",
    components: {LayoutMachineIntroduction},
    data() {
        return {
            isAccordionClosed: {
                cont1: true,
                cont2: false,
                daily: true,
                school: true,
                season: true,
                anniversary: true,
                trend_design: true
            },
        }
    },
    props: {
        /**
         * Headerコンポーネント用
         * 未保存プリ数
         */
        unsavedPuriCount: {
            type: String,
            required: true
        },
        /**
         * Headerコンポーネント用
         * 最新プリID
         */
        latestImageId: {
            type: String,
            required: true
        },
        /**
         * 当該機種が「遊べるお店を探す」によって検索可能であるかどうかを判定する.
         * toolboxから取得
         * 「遊べるお店を探す」表示判定
         */
        isSearchable: {
            type: Boolean,
            required: true
        },
    },
    computed: {
        machineId() {
            return 158;
        },
        sectionTitleList() {
            return [];
        },
    },
    mounted() {
        /**
         * TheHeader,TheFooterでstoreのaccountStatusを使用するため、予めstoreに保存しておく
         * FIXME:ここでの取得を忘れてもエラーが出ず気づかない可能性があるため、VOYAGERFRONT-5558で修正予定
         */
        this.getAccountStatus()
    },
    methods: {
        ...mapActions({
            getAccountStatus: 'AccountStoreV2/getAccountStatus'
        }),
        /**
         * 画像のURLを組み立てる
         * @param {string} imgName 画像名
         */
        buildImgUrl(imgName) {
            return urlUtil.imageUrlUtil.machineIntroductionImageUrl(String(this.machineId), imgName)
        },

        /**
         * cssのurl関数に動的な文字列を与えようとすると、上手くcssの関数が呼び出せなかったので、
         * url関数の呼び出し部分の含めた文字列をv-bindで組み立てからstyleで使えるようにしている
         */
        buildStyleImgUrl(imageName) {
            const imgUrl = this.buildImgUrl(imageName)
            return `url(${imgUrl})`;
        },
        /**
         * 閉じる開くの表示切り替えをする
         */
        switchingOpenClosed(key) {
            this.isAccordionClosed[key] = !this.isAccordionClosed[key];
        },

    }
}
</script>

<style scoped lang="scss">
@use "sass:math";
@use "../../../../scss/v2/base/variables";

$deviceWidth: 750px;

:deep(*) {
    .c-machine-introduction {
        &-top {
            .btn-puri-list {
                position: absolute;
                width: math.percentage(math.div(168px, $deviceWidth));
                bottom: math.percentage(math.div(300px, $deviceWidth));
                right: math.percentage(math.div(10px, $deviceWidth));
            }

            .btn-shop-list {
                position: absolute;
                top: math.percentage(math.div(455px, $deviceWidth));
                left: 0;
                width: 100%;

                &-link {
                    width: math.percentage(math.div(530px, $deviceWidth));
                }
            }
        }

        &-contents {
            .accordion-inner {
                .cont-02 {
                    .img-wrapper {
                        position: relative;

                        .show-or-close-btn {
                            position: absolute;
                            top: 74%;
                            right: 0;
                            left: 0;
                            margin: 0 auto;
                            width: math.percentage(math.div(300px, $deviceWidth));
                        }
                    }
                }
            }
            img {
                // 画像の間に実際に隙間がなくてもあるように見えてしまい、ブラウザのレンダリングの違いによると推測している
                // ここでは詰めることで茶を濁している
                margin-bottom: -0.5px;
            }

        }

        &-movie {
            background-image: v-bind("buildStyleImgUrl('movie_back.png')");
            background-repeat: no-repeat;
            background-size: 100%;
            padding: 35% 0 24%;
            background-position: center;

            &-thumb {
                width: math.percentage(math.div(650px, $deviceWidth));
                margin: 6% auto 0;
            }
        }
    }
}
</style>
